import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface HeroDescriptionProps {
  children: ReactNode
  className?: string
}

/**
 * HeroDescription Component
 *
 * Componente de descrição/subtítulo do Hero.
 * Texto menor que aparece abaixo do título principal.
 *
 * @example
 * ```tsx
 * <HeroDescription>
 *   Tãmi é a ferramenta para que você seja o Creator que sempre quis ser:
 *   eficiente, lucrativo e com tempo para o que realmente importa.
 * </HeroDescription>
 * ```
 */
export function HeroDescription({ children, className }: HeroDescriptionProps) {
  return (
    <p
      className={cn(
        'text-base md:text-lg lg:text-xl',
        'text-tami-black',
        'font-normal',
        'max-w-xl',
        className
      )}
    >
      {children}
    </p>
  )
}
